import { hasEveryRequiredResource } from '../../../helpers/resourceAllocations';

const clockTime = (value) => {
  if (typeof value !== "string") return "";
  const match = value.trim().match(/(?:^|[T\s])(\d{2}:\d{2})(?::\d{2})?(?:$|[Z+-])/);
  return match ? match[1] : "";
};

export const isSelectedAutofillTimeAvailable = (startDatetime, availableTimes) => {
  const selected = clockTime(startDatetime);
  return Boolean(selected) && Array.isArray(availableTimes) && availableTimes.some((time) => clockTime(time) === selected);
};

export const selectedAutofillTimeFeedback = (startDatetime, availableTimes) => {
  if (!startDatetime || !Array.isArray(availableTimes) || availableTimes.length === 0) return "";
  return isSelectedAutofillTimeAvailable(startDatetime, availableTimes)
    ? ""
    : "The selected time is not available. Please choose another available time.";
};

export const canConfirmAutofill = (values, availableTimes, resourceOptions, { allowStaffOverlap = false } = {}) =>
  Boolean(values?.service_id && values?.start_time)
  && (allowStaffOverlap ? Boolean(clockTime(values.start_datetime)) : isSelectedAutofillTimeAvailable(values.start_datetime, availableTimes))
  && (!values.resource_required || (
    Boolean(values.resource_item_id)
    && hasEveryRequiredResource(resourceOptions, values.resource_allocations)
  ));
